import classNames from "classnames";
import { ReactNode } from "react";
import "./Category.scss";

const Category = ({
	className,
	children,
}: {
	className: string;
	children: ReactNode;
}) => {
	return (
		<div className={classNames("category row", className)}>
			<span className="category__color"></span>
			{children}
		</div>
	);
};

export default Category;
